








import {Vue, Component} from 'vue-property-decorator';
import {graph} from '@pnp/graph/presets/all';
import {sp} from '@pnp/sp/presets/all';
import {UserAgentApplication, AuthError} from 'msal';
import {PnPFetchClient} from "@/pnp/PnPFetchClient";

@Component
export default class Auth extends Vue {
    authenticated = false
    renewIframe = false
    hasError = false
    errorMessage = ''

    async mounted() {
        const msalConfig = {
            auth: {
                authority: process.env.VUE_APP_FHK_CONFIG_AUTHORITY,
                clientId: process.env.VUE_APP_FHK_CONFIG_CLIENT_ID
            }
        };

        const msalInstance = new UserAgentApplication(msalConfig);
        this.$store.commit('updateMsalInstance', msalInstance)

        const initPnPjs = async () => {
            const fetchClientFactory = () => {
                return new PnPFetchClient(msalInstance);
            };

            sp.setup({
                sp: {
                    fetchClientFactory,
                    baseUrl: process.env.VUE_APP_FHK_SP_SITE_URL
                }
            });

            graph.setup({
                graph: {
                    fetchClientFactory
                }
            });
        }

        // action to perform on authentication
        msalInstance.handleRedirectCallback(() => { // on success
            this.authenticated = true
            initPnPjs();
        }, (authErr: AuthError, accountState: string) => {  // on fail
            console.log(authErr);

            this.hasError = true
            this.errorMessage = authErr.errorMessage
        });

        // if we are inside renewal callback (hash contains access token), do nothing
        if (msalInstance.isCallback(window.location.hash)) {
            this.renewIframe = true
            return;
        }

        // not logged in, perform full page redirect
        if (!msalInstance.getAccount()) {
            msalInstance.loginRedirect({});
            return;
        } else {     // logged in, set authenticated state and init pnpjs library
            this.authenticated = true
            initPnPjs();
        }
    }

}
